import { AlgorithmStatus } from './schemas';
import { TOfflineSalesOptimizerModes } from '../offlineSalesOptimizer/common';

import { OfflineSalesOptimizerStrategy } from '@/features/offlineSalesOptimizer';
export interface AlgorithmsData {
  id: number;
  name: string;
  color: string;
  version: string | null;
}

export interface AlgorithmMediaPlan {
  id: number;
  name: string;
}

export interface AlgorithmsStatus extends AlgorithmsData {
  level: string;
  status: AlgorithmStatus;
  mediaPlan: AlgorithmMediaPlan | null;
}

export interface OfflineSalesOptimizerAlgoConfig {
  strategy: OfflineSalesOptimizerStrategy;
  dataMode: TOfflineSalesOptimizerModes;
}

export interface StarvationBidderAlgoConfig {
  productivityMeasure: 'cpm' | 'cpcv' | 'vcpm' | 'cpe' | 'cpv';
  goal: number;
}

export enum ENTITY_TYPE {
  ADVERTISER = 'advertiser',
  CAMPAIGN = 'campaign',
  META_CAMPAIGN = 'meta_campaign',
  ADGROUP = 'ad_group',
  ADSET = 'ad_set',
  INSERTION_ORDER = 'insertion_order',
}
export interface ApplyRemoveAlgorithmRequestData {
  entityType: ENTITY_TYPE;
  action: 'apply' | 'remove';
  algorithmIds: number[];
  entities: {
    entityId: string;
    entityName: string;
  }[];
  userConfigurations?:
    | OfflineSalesOptimizerAlgoConfig
    | StarvationBidderAlgoConfig;
  mediaPlan?: number;
}

export interface ApplyRemoveAlgorithmResponseData {
  entityType: ENTITY_TYPE;
  action: ApplyRemoveAlgorithmRequestData['action'];
  status: 'success' | 'partial_success' | 'error';
  results: {
    id: string;
    name: string;
    statuses: {
      id: string;
      algorithmName: string;
      color: string;
      status: 'Success' | 'Failed';
      statusMessage: string;
      version: string | null;
    }[];
  }[];
}

export interface TraffickingAdvertiserData {
  advertiserId: string;
  advertiserName: string;
  algorithmStatus: AlgorithmStatus;
  algorithms: AlgorithmsStatus[];
}

export interface TraffickingCampaignData {
  id: string;
  campaignId: string;
  campaignName: string;
  budget: number | null;
  startDate: string;
  endDate: string;
  advertiserId?: string;
  advertiserName?: string;
  algorithmStatus: AlgorithmStatus;
  algorithms: AlgorithmsStatus[];
}

export interface TraffickingAdGroupData {
  id: string;
  adGroupId: string;
  adGroupName: string;
  campaignId: string;
  campaignName: string;
  insertionOrderId?: string;
  insertionOrderName?: string;
  algorithmStatus: AlgorithmStatus;
  algorithms: AlgorithmsStatus[];
}

export interface TraffickingInsertionOrderData {
  id: string;
  insertionOrderId: string;
  insertionOrderName: string;
  campaignId: string;
  campaignName: string;
  budget: number | null;
  startDate: string;
  endDate: string;
  algorithmStatus: AlgorithmStatus;
  algorithms: AlgorithmsStatus[];
}

export type RawTraffickingAdGroupData = Omit<
  TraffickingAdGroupData,
  'adGroupId' | 'adGroupName'
> & {
  adGroupId?: string;
  adGroupName?: string;
  adSetId?: string;
  adSetName?: string;
};
